import React from 'react';

function PageNotFound() {
  return <div>404 PageNotFound</div>;
}

export default PageNotFound;
